Task = function (eventName, details) {
  var self = this;
  self.name = eventName;
  self.data = details;
  self.referenceCount = 0;
  self.isDead = false;
  self.deadCB = undefined;
};

Task.prototype.join = function () {
  ++this.referenceCount;
  return this;
};

Task.prototype.leave = function () {
  if (--this.referenceCount === 0) {
    this.sendDead();
  }
};

Task.prototype.sendDead = function () {
  this.isDead = true;
  if (this.deadCB) this.deadCB();
  this.deadCB = undefined;
};
